<template>
    <div id="map" class="map min-h-[600px] mb-5"></div>
</template>

<script>
import {ref, onMounted} from 'vue';
import "leaflet/dist/leaflet.css"
import 'vue-leaflet-markercluster/dist/style.css'
import * as L from 'leaflet';
import {MarkerClusterGroup} from "leaflet.markercluster/src";
const initialMap = ref(null);


export default {
    name: "RtpMap",
    props: {
        mapdata: {
            type: String,
            required: true
        },
        tilelayer: {
            type: String,
            required: true
        },
        attribution: {
            type: String,
            required: true
        }
    },
    data: {
        mapDataParsed: [],
        tileLayerParsed: null,
        attributionParsed: null
    },
    mounted: function () {
        this.mapDataParsed = JSON.parse(this.mapdata);
        this.tileLayerParsed = this.tilelayer;
        this.attributionParsed = this.attribution;
        // initialMap.value = L.map('map').setView([20, 20], 2);
        // L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        //     maxZoom: 19,
        //     attribution: this.attribution
        // }).addTo(initialMap.value);

        var initialMap = L.map('map').setView([20, 20], 2);
        L.tileLayer(this.tileLayerParsed, {attribution: this.attributionParsed}).addTo(initialMap);
        var markers = L.markerClusterGroup({
            chunkedLoading: true,
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
        });

        for (let i = 0; i < this.mapDataParsed.length; i++) {
            var point = this.mapDataParsed[i];
            var marker = L.marker([point.Lat, point.Lng]);
            marker.bindPopup(point.PopupText);
            markers.addLayer(marker);
        }

        initialMap.addLayer(markers);


    }
}
</script>


<style>
@import 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
@import 'https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.css';


.map {
    min-height: 600px;
    max-height: 100vh;
    z-index: 0;
}

.marker-cluster {
    border-radius: 20px;
    background-clip: padding-box;
    background-color: rgba(43, 130, 203, 0.33);
}

.marker-cluster div {
    width: 30px;
    height: 30px;
    margin-top: 5px;
    margin-left: 5px;
    border-radius: 15px;
    background-color: #2b82cb;
    color: white;
    text-align: center;
}

.marker-cluster span {
    line-height: 30px;
}


</style>
